import React from 'react';

/* Escribe el texto letra por letra al montar, con un cursor parpadeante mientras escribe. */
const TypewriterText: React.FC<{ text: string; speed?: number; startDelay?: number; className?: string }> = ({ text, speed = 42, startDelay = 500, className }) => {
  const [count, setCount] = React.useState(0);
  const [prevText, setPrevText] = React.useState(text);
  if (prevText !== text) {
    setPrevText(text);
    setCount(0);
  }

  React.useEffect(() => {
    let interval: ReturnType<typeof setInterval>;
    const timeout = setTimeout(() => {
      interval = setInterval(() => {
        setCount((c) => {
          if (c >= text.length) {
            clearInterval(interval);
            return c;
          }
          return c + 1;
        });
      }, speed);
    }, startDelay);
    return () => { clearTimeout(timeout); clearInterval(interval); };
  }, [text, speed, startDelay]);

  const done = count >= text.length;

  return (
    <span className={className} role="text" aria-label={text}>
      <span aria-hidden="true">
        {text.slice(0, count)}
        {!done && <span className="typewriter-cursor" />}
      </span>
    </span>
  );
};

export default TypewriterText;
